import { render, useEffect, useRef } from '@wordpress/element';

import './style.scss';
import Style from './Style';

// Pricing Table
document.addEventListener('DOMContentLoaded', () => {
	const allPricingTables = document.querySelectorAll('.wp-block-bptb-pricing-table');
	allPricingTables.forEach(priceTable => {
		const attributes = JSON.parse(priceTable.dataset.attributes);

		const isBasic = priceTable.className.includes('basic');
		const isStandard = priceTable.className.includes('standard');
		const isUltimate = priceTable.className.includes('ultimate');

		render(<>
			<Style attributes={attributes} clientId={attributes.cId} isStandard={isStandard} />

			<PricingTable attributes={attributes} clientId={attributes.cId} isBasic={isBasic} isStandard={isStandard} isUltimate={isUltimate} />
		</>, priceTable);

		priceTable?.removeAttribute('data-attributes');
	});
});

const PricingTable = ({ attributes, clientId, isBasic, isStandard, isUltimate }) => {
	const { pricingTables, columns } = attributes;

	useEffect(() => {
		const priceFeaturesAll = document.querySelectorAll(`#bptbPricingTables-${clientId} .bptbPricingTables .bptbPriceTable .priceFeatures`);
		const priceFeaturesHeight = [];

		priceFeaturesAll?.forEach(priceFeatures => {
			priceFeaturesHeight.push(priceFeatures?.clientHeight);
		});

		priceFeaturesAll?.forEach(priceFeatures => {
			priceFeatures.style.height = Math.max(...priceFeaturesHeight) + 'px';
		});
	}, [pricingTables]);

	return <div className={`bptbPricingTables columns-${columns.desktop} columns-tablet-${columns.tablet} columns-mobile-${columns.mobile}`}>
		{pricingTables?.map((priceTable, index) => {
			const { name, price, priceCurrency, period, link, linkLabel, features } = priceTable;

			const priceTableEl = useRef(null);
			const priceAmountWrapEl = useRef(null);

			useEffect(() => {
				if (isUltimate) {
					const widthOfPriceWrap = priceTableEl?.current?.clientHeight / 100 * 82;

					priceAmountWrapEl.current.style.width = `${widthOfPriceWrap}px`;
					priceAmountWrapEl.current.style.top = `${widthOfPriceWrap / 2}px`;
					priceAmountWrapEl.current.style.left = `${-widthOfPriceWrap / 2 + 60}px`;
				}
			}, []);

			const priceAmountEl = <span className='priceAmount'>{priceCurrency}{price}</span>;
			const pricePeriodEl = <span className='pricePeriod'>{period}</span>;

			return <div key={index} id={`bptbPriceTable-${index}`}>
				<div className='bptbPriceTable' ref={priceTableEl}>
					<h3 className='priceName'>{name}</h3>

					{isStandard || isUltimate ? <div className='priceAmountWrap' ref={priceAmountWrapEl}>{priceAmountEl} / {pricePeriodEl}</div> : ''}

					<div className='priceFeatures'>
						{features?.map((feature, featureIndex) => {
							const { isEnable, label } = feature;

							return <div key={featureIndex} className='priceFeature'>
								{isEnable ? <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 512 512' className='priceFeatureEnabled'><path fill='#01944e' d='M173.898 439.404l-166.4-166.4c-9.997-9.997-9.997-26.206 0-36.204l36.203-36.204c9.997-9.998 26.207-9.998 36.204 0L192 312.69 432.095 72.596c9.997-9.997 26.207-9.997 36.204 0l36.203 36.204c9.997 9.997 9.997 26.206 0 36.204l-294.4 294.401c-9.998 9.997-26.207 9.997-36.204-.001z' /></svg> : <svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 352 512' className='priceFeatureDisabled'><path fill='#f00025' d='M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z' /></svg>}

								<span className='priceFeatureLabel'>{label}</span>
							</div>;
						})}
					</div>

					{!isStandard || !isUltimate ? <div className='priceAmountWrap'>{priceAmountEl}</div> : ''}
					{!isBasic && <br />}

					<a className='priceLink' href={link}>{linkLabel}</a>
				</div>
			</div>;
		})}
	</div>
}